<template>
  <div id="app-container">
    <el-form ref="form" :model="data" label-width="68px">
      <el-form-item label="归属机构">
        <el-select v-model="data.DpId" placeholder="请选择" @change="dpChange" filterable style="width:260px;">
          <el-option v-for="item in TreeData" :key="item.DpId" :value="item.DpId" :label="item.DpName" />
        </el-select>
        <!-- <tree-select
          ref="treeSelect"
          :props="props"
          :options="TreeData"
          :value="data.DpId"
          :clearable="false"
          :accordion="true"
          :parentSelect="true"
          placeholder="请选择"
          style="width:260px;"
          @node-select="onTreeSelect($event)"
        /> -->
      </el-form-item>
      <el-form-item label="模板类型" v-if="data.DpId">
        <el-select v-model="data.TempType" @change="typeChange" style="width:260px;">
          <el-option :value="0" label="学时表"/>
          <el-option :value="1" label="日志表"/>
          <el-option :value="2" label="结业证"/>
          <el-option :value="3" label="学员登记表"/>
        </el-select>
        <i class="el-icon-loading" v-if="loading" style="margin: 0 3px 0 10px;color:#409eff;"></i><span v-if="loading" style="color:#409eff;">加载中</span>
      </el-form-item>
    </el-form>
    <div v-if="ready" class="setting-box">
      <div class="title">驾校</div>
      <el-row class="temp-border">
        <el-col :span="3">
          <el-checkbox v-model="data.DsShowDate" class="mix-checkbox" :disabled="readonly">显示日期</el-checkbox>
        </el-col>
        <el-col :span="3">
          <el-checkbox v-model="data.DsShowSign" class="mix-checkbox" :disabled="readonly">显示签名</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="data.DsShowSignature" class="mix-checkbox" :disabled="readonly">显示签章</el-checkbox>
        </el-col>
        <el-col :span="6">
          <span class="form-title">签名类型</span>
          <el-select v-model="data.DsSignType" :disabled="readonly" :placeholder="readonly?'':'请选择'"  >
            <el-option :value="0" label="审核人"/>
            <el-option :value="1" label="指定签名"/>
          </el-select>
        </el-col>
        <el-col :span="8">
          <span class="form-title">签名方式</span>
          <el-select v-model="DsSignWay" multiple :disabled="readonly" :placeholder="readonly?'':'请选择'" @change="mulChange('DsSignWay')" style="width:250px;"  >
            <el-option value="文字"/>
            <el-option value="电子签名"/>
            <el-option value="电子签章"/>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span class="form-title">指定签名</span>
          <el-input v-model="data.DsSpecifySign" :disabled="readonly" :placeholder="readonly?'':'请填写指定签名'"  ></el-input>
        </el-col>
        <el-col :span="6">
          <span class="form-title">指定电子签名图片</span>
          <el-button-group v-if="!readonly">
            <el-upload
              v-if="!uploading||uploadName!='DsSpecifySignUrl'"
              class="upload-demo"
              :action="host + '/api/Common/UploadPicture'"
              :multiple="false"
              :headers="headers"
              :show-file-list="false"
              accept=".jpg,.png,.jpeg"
              :on-success="onFileSuccess"
              :before-upload="beforeUpload">
              <el-button type="primary" :disabled="readonly" @click="uploadName='DsSpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
            </el-upload>
            <el-button type="primary" v-else disabled :loading="uploadName=='DsSpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
            <el-button type="primary" style="float:right;" :disabled="!data.DsSpecifySignUrl" @click="toPreview('DsSpecifySignUrl')">预览<i class="el-icon-picture el-icon--right"/></el-button>
          </el-button-group>
          <el-button type="primary" v-else @click="toPreview('DsSpecifySignUrl')" :disabled="!data.DsSpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
        </el-col>
        <el-col :span="9">
          <span class="form-title">指定电子签章图片</span>
          <el-button-group v-if="!readonly">
            <el-upload
              v-if="!uploading||uploadName!='DsSpecifySignatureUrl'"
              class="upload-demo"
              :action="host + '/api/Common/UploadPicture'"
              :multiple="false"
              :headers="headers"
              :show-file-list="false"
              accept=".jpg,.png,.jpeg"
              :on-success="onFileSuccess"
              :before-upload="beforeUpload">
              <el-button type="primary" :disabled="readonly" @click="uploadName='DsSpecifySignatureUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
            </el-upload>
            <el-button type="primary" v-else disabled :loading="uploadName=='DsSpecifySignatureUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
            <el-button type="primary" style="float:right;" :disabled="!data.DsSpecifySignatureUrl" @click="toPreview('DsSpecifySignatureUrl')">预览<i class="el-icon-picture el-icon--right"/></el-button>
          </el-button-group>
          <el-button type="primary" v-else @click="toPreview('DsSpecifySignatureUrl')" :disabled="!data.DsSpecifySignatureUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
        </el-col>
      </el-row>

      <div class="title">学员</div>
      <el-row class="temp-border">
        <el-col :span="3">
          <el-checkbox v-model="data.StShowDate" class="mix-checkbox" :disabled="readonly">显示日期</el-checkbox>
        </el-col>
        <el-col :span="3">
          <el-checkbox v-model="data.StShowSign" class="mix-checkbox" :disabled="readonly">显示签名</el-checkbox>
        </el-col>
        <el-col :span="4">
          <el-checkbox v-model="data.StShowSignature" class="mix-checkbox" :disabled="readonly">显示签章</el-checkbox>
        </el-col>
        <el-col :span="6">
          <span class="form-title">签名类型</span>
          <el-select v-model="data.StSignType" :disabled="readonly" :placeholder="readonly?'':'请选择'"  >
            <el-option :value="0" label="学员签名"/>
            <el-option :value="1" label="指定签名"/>
          </el-select>
        </el-col>
        <el-col :span="6">
          <span class="form-title">指定签名</span>
          <el-input v-model="data.StSpecifySign" :disabled="readonly" :placeholder="readonly?'':'请填写指定签名'"  ></el-input>
        </el-col>
      </el-row>

      <div class="title">教练</div>
      <el-row class="temp-border">
        <el-row>
          <div class="title2">科目二</div>
          <el-divider />
          <el-col :span="3">
            <el-checkbox v-model="data.Co2ShowDate" class="mix-checkbox" :disabled="readonly">显示日期</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox v-model="data.Co2ShowSign" class="mix-checkbox" :disabled="readonly">显示签名</el-checkbox>
          </el-col>
          <el-col :span="6">
            <span class="form-title">签名类型</span>
            <el-select v-model="data.Co2SignType" :disabled="readonly" :placeholder="readonly?'':'请选择'"  >
              <el-option :value="0" label="带教教练"/>
              <el-option :value="1" label="指定签名"/>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span class="form-title">签名方式</span>
            <el-select v-model="Co2SignWay" multiple :disabled="readonly" :placeholder="readonly?'':'请选择'" @change="mulChange('Co2SignWay')" style="width:250px;"  >
              <el-option value="文字"/>
              <el-option value="电子签名"/>
            </el-select>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定签名</span>
            <el-input v-model="data.Co2SpecifySign" :disabled="readonly" :placeholder="readonly?'':'请填写指定签名'"  ></el-input>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定电子签名图片</span>
            <el-button-group v-if="!readonly">
              <el-upload
                v-if="!uploading||uploadName!='Co2SpecifySignUrl'"
                class="upload-demo"
                :action="host + '/api/Common/UploadPicture'"
                :multiple="false"
                :headers="headers"
                :show-file-list="false"
                accept=".jpg,.png,.jpeg"
                :on-success="onFileSuccess"
                :before-upload="beforeUpload">
                <el-button type="primary" :disabled="readonly" @click="uploadName='Co2SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              </el-upload>
              <el-button type="primary" v-else disabled :loading="uploadName=='Co2SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              <el-button type="primary" style="float:right;" :disabled="!data.Co2SpecifySignUrl" @click="toPreview('Co2SpecifySignUrl')">预览<i class="el-icon-picture el-icon--right"/></el-button>
            </el-button-group>
            <el-button type="primary" v-else @click="toPreview('Co2SpecifySignUrl')" :disabled="!data.Co2SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
          </el-col>
        </el-row>
        
        <el-row>
          <div class="title2" style="margin-top:20px;">科目三</div>
          <el-divider />
          <el-col :span="3">
            <el-checkbox v-model="data.Co3ShowDate" class="mix-checkbox" :disabled="readonly">显示日期</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox v-model="data.Co3ShowSign" class="mix-checkbox" :disabled="readonly">显示签名</el-checkbox>
          </el-col>
          <el-col :span="6">
            <span class="form-title">签名类型</span>
            <el-select v-model="data.Co3SignType" :disabled="readonly" :placeholder="readonly?'':'请选择'"  >
              <el-option :value="0" label="带教教练"/>
              <el-option :value="1" label="指定签名"/>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span class="form-title">签名方式</span>
            <el-select v-model="Co3SignWay" multiple :disabled="readonly" :placeholder="readonly?'':'请选择'" @change="mulChange('Co3SignWay')" style="width:250px;"  >
              <el-option value="文字"/>
              <el-option value="电子签名"/>
            </el-select>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定签名</span>
            <el-input v-model="data.Co3SpecifySign" :disabled="readonly" :placeholder="readonly?'':'请填写指定签名'"  ></el-input>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定电子签名图片</span>
            <el-button-group v-if="!readonly">
              <el-upload
                v-if="!uploading||uploadName!='Co3SpecifySignUrl'"
                class="upload-demo"
                :action="host + '/api/Common/UploadPicture'"
                :multiple="false"
                :headers="headers"
                :show-file-list="false"
                accept=".jpg,.png,.jpeg"
                :on-success="onFileSuccess"
                :before-upload="beforeUpload">
                <el-button type="primary" :disabled="readonly" @click="uploadName='Co3SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              </el-upload>
              <el-button type="primary" v-else disabled :loading="uploadName=='Co3SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              <el-button type="primary" style="float:right;" @click="toPreview('Co3SpecifySignUrl')" :disabled="!data.Co3SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
            </el-button-group>
            <el-button type="primary" v-else @click="toPreview('Co3SpecifySignUrl')" :disabled="!data.Co3SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
          </el-col>
        </el-row>
      </el-row>

      <div class="title">考核员</div>
      <el-row class="temp-border" style="margin-bottom:4px;">
        <el-row>
          <div class="title2">科目二</div>
          <el-divider />
          <el-col :span="3">
            <el-checkbox v-model="data.Ch2ShowDate" class="mix-checkbox" :disabled="readonly">显示日期</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox v-model="data.Ch2ShowSign" class="mix-checkbox" :disabled="readonly">显示签名</el-checkbox>
          </el-col>
          <el-col :span="6">
            <span class="form-title">签名类型</span>
            <el-select v-model="data.Ch2SignType" :disabled="readonly" :placeholder="readonly?'':'请选择'"  >
              <el-option :value="0" label="带教教练"/>
              <el-option :value="1" label="指定签名"/>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span class="form-title">签名方式</span>
            <el-select v-model="Ch2SignWay" multiple :disabled="readonly" :placeholder="readonly?'':'请选择'" @change="mulChange('Ch2SignWay')" style="width:250px;"  >
              <el-option value="文字"/>
              <el-option value="电子签名"/>
            </el-select>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定签名</span>
            <el-input v-model="data.Ch2SpecifySign" :disabled="readonly" :placeholder="readonly?'':'请填写指定签名'"  ></el-input>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定电子签名图片</span>
            <el-button-group v-if="!readonly">
              <el-upload
                v-if="!uploading||uploadName!='Ch2SpecifySignUrl'"
                class="upload-demo"
                :action="host + '/api/Common/UploadPicture'"
                :multiple="false"
                :headers="headers"
                :show-file-list="false"
                accept=".jpg,.png,.jpeg"
                :on-success="onFileSuccess"
                :before-upload="beforeUpload">
                <el-button type="primary" :disabled="readonly" @click="uploadName='Ch2SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              </el-upload>
              <el-button type="primary" v-else disabled :loading="uploadName=='Ch2SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              <el-button type="primary" style="float:right;" @click="toPreview('Ch2SpecifySignUrl')" :disabled="!data.Ch2SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
            </el-button-group>
            <el-button type="primary" v-else @click="toPreview('Ch2SpecifySignUrl')" :disabled="!data.Ch2SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
          </el-col>
        </el-row>
        
        <el-row>
          <div class="title2" style="margin-top:20px;">科目三</div>
          <el-divider />
          <el-col :span="3">
            <el-checkbox v-model="data.Ch3ShowDate" class="mix-checkbox" :disabled="readonly">显示日期</el-checkbox>
          </el-col>
          <el-col :span="3">
            <el-checkbox v-model="data.Ch3ShowSign" class="mix-checkbox" :disabled="readonly">显示签名</el-checkbox>
          </el-col>
          <el-col :span="6">
            <span class="form-title">签名类型</span>
            <el-select v-model="data.Ch3SignType" :disabled="readonly" :placeholder="readonly?'':'请选择'"  >
              <el-option :value="0" label="带教教练"/>
              <el-option :value="1" label="指定签名"/>
            </el-select>
          </el-col>
          <el-col :span="8">
            <span class="form-title">签名方式</span>
            <el-select v-model="Ch3SignWay" multiple :disabled="readonly" :placeholder="readonly?'':'请选择'" @change="mulChange('Ch3SignWay')" style="width:250px;"  >
              <el-option value="文字"/>
              <el-option value="电子签名"/>
            </el-select>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定签名</span>
            <el-input v-model="data.Ch3SpecifySign" :disabled="readonly" :placeholder="readonly?'':'请填写指定签名'"  ></el-input>
          </el-col>
          <el-col :span="6">
            <span class="form-title">指定电子签名图片</span>
            <el-button-group v-if="!readonly">
              <el-upload
                v-if="!uploading||uploadName!='Ch3SpecifySignUrl'"
                class="upload-demo"
                :action="host + '/api/Common/UploadPicture'"
                :multiple="false"
                :headers="headers"
                :show-file-list="false"
                accept=".jpg,.png,.jpeg"
                :on-success="onFileSuccess"
                :before-upload="beforeUpload">
                <el-button type="primary" :disabled="readonly" @click="uploadName='Ch3SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              </el-upload>
              <el-button type="primary" v-else disabled :loading="uploadName=='Ch3SpecifySignUrl'">上传<i class="el-icon-upload el-icon--right"/></el-button>
              <el-button type="primary" style="float:right;" @click="toPreview('Ch3SpecifySignUrl')" :disabled="!data.Ch3SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
            </el-button-group>
            <el-button type="primary" v-else @click="toPreview('Ch3SpecifySignUrl')" :disabled="!data.Ch3SpecifySignUrl">预览<i class="el-icon-picture el-icon--right"/></el-button>
          </el-col>
        </el-row>
      </el-row>
    </div>
    <el-row class="footer-row" v-if="ready">
      <el-col :span="24" id="footer">
        <el-button v-if="!readonly" type="primary" size="medium" @click="save" style="float:right;" :loading="loading">保 存</el-button>
      </el-col>
    </el-row>
    <pic-dialog ref="picDialog" :readonly="readonly" @del="delPic" />
  </div>
</template>
<script>
import treeSelect from "@/components/common/treeSelect";
import picDialog from "./picDialog.vue";
export default {
  name: "template",
  components: {
    treeSelect,
    picDialog
  },
  mounted() {
    this.readonly = !this.$permission.canEdit();
    this.getTreeData();
  },
  data() {
    return {
      boxWidth: "",
      data: {
        DsTempId: 0,
        DpId: null,
        TempType: null,
        DsShowDate: false,
        DsShowSign: false,
        DsShowSignature: false,
        DsSignType: null,
        DsSignWay: "",
        DsSpecifySign: "",
        //--图片--
        DsSpecifySignUrl: "",
        DsSpecifySignatureUrl: "",
        //--------
        StShowDate: false,
        StShowSign: false,
        StShowSignature: false,
        StSignType: null,
        StSpecifySign: "",
        Co2ShowDate: false,
        Co2ShowSign: false,
        Co2SignType: null,
        Co2SignWay: "",
        Co2SpecifySign: "",
        //--图片--
        Co2SpecifySignUrl: "",
        //--------
        Co3ShowDate: false,
        Co3ShowSign: false,
        Co3SignType: null,
        Co3SignWay: "",
        Co3SpecifySign: "",
        //--图片--
        Co3SpecifySignUrl: "",
        //--------
        Ch2ShowDate: false,
        Ch2ShowSign: false,
        Ch2SignType: null,
        Ch2SignWay: "",
        Ch2SpecifySign: "",
        //--图片--
        Ch2SpecifySignUrl: "",
        //--------
        Ch3ShowDate: false,
        Ch3ShowSign: false,
        Ch3SignType: null,
        Ch3SignWay: "",
        Ch3SpecifySign: "",
        //--图片--
        Ch3SpecifySignUrl: "",
        //--------
      },
      DsSignWay: [],
      Co2SignWay: [],
      Co3SignWay: [],
      Ch2SignWay: [],
      Ch3SignWay: [],
      TreeData: [],
      uploadName: "",
      api: require("@/api/sy/template").default,
      dpApi: require("@/api/basic/dp").default,
      comApi: require("@/api/common/common").default,
      props: {
        value: "DpId",
        label: "DpName",
        children: "children",
      },
      readonly: true,
      loading: false,
      ready: false,
      uploading: false,
      headers: { Authorization: "" },
    }
  },
  computed: {
    host() {
      return window.location.origin;
    }
  },
  methods: {
    checkNum(v) {
      if(!(this.data[v]>0)) {
        this.data[v] = 0;
      }
    },
    mulChange(v) {
      var result = "";
      for (let i = 0; i < this[v].length; i++) {
        var e = this[v][i];
        result += e;
        if(i < this[v].length-1) {
          result += ","
        }
      }
      this.data[v] = result;
    },
    getTreeData() {
      this.dpApi.getAuthList({ DpTypes: [2], NoReturnParent: true }).then(res => {
        if(res.Data.length==1) {
          this.data.DpId = res.Data[0].DpId;
          // this.$refs.treeSelect.setData(res.Data[0].DpId);
        }
        this.TreeData = res.Data;
        // this.TreeData = this.$commonJs.toTreeData(res.Data, "DpId");
      });
    },
    onTreeSelect(t) {
      this.data.DpId = t.DpId;
      if(!(this.data.TempType === null)) {
        this.getData();
      }
    },
    dpChange(v) {
      if(!(this.data.TempType === null)) {
        this.getData();
      }
    },
    typeChange() {
      this.getData();
    },
    getData(dpId=this.data.DpId) {
      this.loading = true;
      this.ready = false;
      this.api.getInfoByDpIdTempType(dpId,this.data.TempType).then(res => {
        this.loading = false;
        if(res.Code==0) {
          if(res.Data==null) {
            this.data = {
              DsTempId: 0,
              DpId: dpId,
              TempType: this.data.TempType,
              DsShowDate: false,
              DsShowSign: false,
              DsShowSignature: false,
              DsSignType: null,
              DsSignWay: "",
              DsSpecifySign: "",
              DsSpecifySignUrl: "",
              DsSpecifySignatureUrl: "",
              StShowDate: false,
              StShowSign: false,
              StShowSignature: false,
              StSignType: null,
              StSpecifySign: "",
              Co2ShowDate: false,
              Co2ShowSign: false,
              Co2SignType: null,
              Co2SignWay: "",
              Co2SpecifySign: "",
              Co2SpecifySignUrl: "",
              Co3ShowDate: false,
              Co3ShowSign: false,
              Co3SignType: null,
              Co3SignWay: "",
              Co3SpecifySign: "",
              Co3SpecifySignUrl: "",
              Ch2ShowDate: false,
              Ch2ShowSign: false,
              Ch2SignType: null,
              Ch2SignWay: "",
              Ch2SpecifySign: "",
              Ch2SpecifySignUrl: "",
              Ch3ShowDate: false,
              Ch3ShowSign: false,
              Ch3SignType: null,
              Ch3SignWay: "",
              Ch3SpecifySign: "",
              Ch3SpecifySignUrl: "",
            };
            this.DsSignWay =[];
            this.Co2SignWay = [];
            this.Co3SignWay = [];
            this.Ch2SignWay = [];
            this.Ch3SignWay = [];
          } else {
            this.data = res.Data;
            if(res.Data.DsSignWay) {
              this.DsSignWay = res.Data.DsSignWay.split(",");
            }
            if(res.Data.Co2SignWay) {
              this.Co2SignWay = res.Data.Co2SignWay.split(",");
            }
            if(res.Data.Co3SignWay) {
              this.Co3SignWay = res.Data.Co3SignWay.split(",");
            }
            if(res.Data.Ch2SignWay) {
              this.Ch2SignWay = res.Data.Ch2SignWay.split(",");
            }
            if(res.Data.Ch3SignWay) {
              this.Ch3SignWay = res.Data.Ch3SignWay.split(",");
            }
          }
          this.ready = true;
        } else {
          this.$message.error(res.Msg)
        }
      }).catch(err => {
        this.loading = false;
      })
    },
    beforeUpload(file) {
      this.headers.Authorization = "Bearer " + localStorage.getItem("token");
      const isLt1M = file.size / 1024 / 1024 < 1;
      if (!isLt1M) {
        this.$message.error('上传图片大小不能超过1MB');
        return false;
      }
      this.uploading = true;
      return isLt1M;
    },
    onFileSuccess(res) {
      this.uploading = false;
      if(res.Code==0){
        this.data[this.uploadName] = res.Data;
        this.$message.success(res.Msg);
      }else{
        this.$message.error(res.Msg);
      }
    },
    delPic() {
      this.data[this.uploadName] = "";
    },
    toPreview(name) {
      this.uploadName = name;
      var url = this.data[name];
      if(url) {
        this.$refs.picDialog.open(url)
      } else {
        this.$message.warning('暂未上传图片');
      }
    },
    save() {
      var data = this.data;
      if(data.DsSignType === null) {
        this.$message.error("请选择驾校-签名类型");
        return;
      }
      if(data.DsSignType == 1 && !data.DsSpecifySign) {
        this.$message.error("请填写驾校-指定签名");
        return;
      }

      if(data.StSignType === null) {
        this.$message.error("请选择学员-签名类型");
        return;
      }
      if(data.StSignType == 1 && !data.StSpecifySign) {
        this.$message.error("请填写学员-指定签名");
        return;
      }

      if(data.Co2SignType === null) {
        this.$message.error("请选择教练-科目二-签名类型");
        return;
      }
      if(data.Co2SignType == 1 && !data.Co2SpecifySign) {
        this.$message.error("请填写教练-科目二-指定签名");
        return;
      }

      if(data.Co3SignType === null) {
        this.$message.error("请选择教练-科目三-签名类型");
        return;
      }
      if(data.Co3SignType ==1 && !data.Co3SpecifySign) {
        this.$message.error("请填写教练-科目三-指定签名");
        return;
      }

      if(data.Ch2SignType === null) {
        this.$message.error("请选择考核员-科目二-签名类型");
        return;
      }
      if(data.Ch2SignType == 1 && !data.Ch2SpecifySign) {
        this.$message.error("请填写考核员-科目二-指定签名");
        return;
      }

      if(data.Ch3SignType === null) {
        this.$message.error("请选择考核员-科目三-签名类型");
        return;
      }
      if(data.Ch3SignType ==1 && !data.Ch3SpecifySign) {
        this.$message.error("请填写考核员-科目三-指定签名");
        return;
      }
      //------------------------
      if(!data.DsSignWay) {
        this.$message.error("请选择驾校-签名方式");
        return;
      }
      if(!data.Co2SignWay) {
        this.$message.error("请选择教练-科目二-签名方式");
        return;
      }
      if(!data.Co3SignWay) {
        this.$message.error("请选择教练-科目三-签名方式");
        return;
      }
      if(!data.Ch2SignWay) {
        this.$message.error("请选择考核员-科目二-签名方式");
        return;
      }
      if(!data.Ch3SignWay) {
        this.$message.error("请选择考核员-科目三-签名方式");
        return;
      }
      //------------------------
      if(data.DsSignWay.indexOf("电子签名") > - 1 && !data.DsSpecifySignUrl) {
        this.$message.error("请上传驾校-指定电子签名图片");
        return;
      }
      if(data.DsSignWay.indexOf("电子签章") > -1 && !data.DsSpecifySignatureUrl) {
        this.$message.error("请上传驾校-指定电子签章图片");
        return;
      }
      if(data.Co2SignWay.indexOf("电子签名") > - 1 && !data.Co2SpecifySignUrl) {
        this.$message.error("请上传教练-科目二-指定电子签名图片");
        return;
      }
      if(data.Co3SignWay.indexOf("电子签名") > - 1 && !data.Co3SpecifySignUrl) {
        this.$message.error("请上传教练-科目三-指定电子签名图片");
        return;
      }
      if(data.Ch2SignWay.indexOf("电子签名") > - 1 && !data.Ch2SpecifySignUrl) {
        this.$message.error("请上传考核员-科目二-指定电子签名图片");
        return;
      }
      if(data.Ch3SignWay.indexOf("电子签名") > - 1 && !data.Ch3SpecifySignUrl) {
        this.$message.error("请上传考核员-科目三-指定电子签名图片");
        return;
      }
      //------------------------
      this.loading = true;
      this.api.save(data).then(res => {
        this.loading = false;
        if(res.Code==0) {
          this.$message.success("保存成功");
          if(data.DsTempId == 0) {
            this.getData(data.DpId);
          }
        } else {
          this.$message.error(res.Msg)
        }
      }).catch(err => {
        this.loading = false;
      })
    },
  }
};
</script>
<style lang="scss" scoped>
#app-container {
  padding: 20px 30px 63px;
  position: relative;
  // height: 90vh;
  min-width: 1280px;
  overflow-x: auto;
}
.title{
  font-size: 14px;
  color: #606266;
  border-left: 5px solid #409eff;
  height: 20px;
  padding-left: 6px;
}
.title2 {
  font-size: 14px;
  color: #606266;
  margin-top: 4px;
}
.form-title{
  font-size: 14px;
  color: #606266;
  margin-right: 8px;
  margin-top: 12px;
  display: inline-block;
}
.temp-border{
  border: 1px #ddd solid;
  padding: 4px 20px 12px;
  margin: 10px 0 15px;
  .el-input {
    width: 193px;
  }
  .el-checkbox{
    margin-top: 8px;
  }
  .mix-checkbox{
    margin-top: 14px;
  }
}
.setting-box {
  max-height: calc(100vh - 270px);
  overflow-y: auto;
  padding-right: 10px;
}
.footer-row {
  position:absolute;
  bottom: 1px;
  // right: 30px;
  width: calc(100% - 73px);
  background-color: #fff;
}
.table{
  width: 100%;
  font-size: 14px;
  margin-top: 10px;
  .table-title{
    background-color: #aaa;
    line-height: 30px;
    display: flex;
  }
  .item {
    display: flex;
    line-height: 36px;
    border: 1px solid #ddd;
    border-bottom: none;
    .table-input {
      width: 110px;
      margin: 0 4px;
    }
  }
  .table-title > div:nth-child(1),.item > div:nth-child(1) {
    flex: 2;
    text-align: center;
  }
  .table-title > div:nth-child(2),.item > div:nth-child(2) {
    flex: 1;
    text-align: center;
  }
  .table-title > div:nth-child(3),.item > div:nth-child(3) {
    flex: 5;
    text-align: center;
  }
}
#footer{
  border-top: 1px solid #ddd;
  padding: 15px 0;
}
/deep/ .el-icon-question::before{
  vertical-align: middle;
  vertical-align: -1px;
  margin-left: 5px;
  color: #666;
}
/deep/ .el-icon-question:hover{
  &::before{
    color: #409eff !important;
  }
}
/deep/ .is-disabled {
  .el-checkbox__inner::after {
      border-color: #1890ff !important;
  }
}
/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #606266;
}
/deep/ .el-divider--horizontal{
  margin: 6px 0 0;
}
.upload-demo {
  display: inline-block;
  .el-button {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
}
.setting-box::-webkit-scrollbar {
  /*滚动条整体样式*/
  width : 3px;  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.setting-box::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  background   : #ccc;
}
.setting-box::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow   : inset 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background   : #f8f8f8;
}
</style>